var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.694 6.7951C11.102 6.38445 11.102 5.71865 10.694 5.30799C10.286 4.89734 9.62441 4.89734 9.21639 5.30799L3.30602 11.2564C2.89799 11.6671 2.89799 12.3329 3.30602 12.7436L9.21639 18.692C9.62441 19.1027 10.286 19.1027 10.694 18.692C11.102 18.2814 11.102 17.6156 10.694 17.2049L6.51601 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H6.51601L10.694 6.7951Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8565b53ae31988bbd10f5642e1bf84b3.svg";
export { ForwardRef as ReactComponent };